import { defineMessage, FormattedMessage } from 'react-intl';

const intlPrefix = 'shoppingBag';

export const StrapSizeLabel = defineMessage({
  defaultMessage: 'Strap size',
  id: `${intlPrefix}.strapSize`,
});

// Reuses existing translation id owned by StrapView/components/Sizes
export const SizeGuideLabel = defineMessage({
  defaultMessage: 'Size Guide',
  id: 'sizes.sizeGuide',
});

export const StrapSize = <FormattedMessage {...StrapSizeLabel} />;

export const StrapSizeMustBeSelected = (
  <FormattedMessage
    defaultMessage='A strap size must be selected'
    id={`${intlPrefix}.strapSizeMustBeSelected`}
  />
);
